import moment from "moment";
const rp = require("request-promise");

export const fetchRssResults = (url, usePubDate) => {
  return new Promise((resolve, reject) => {
    const options = {
      uri:
        "https://us-central1-melbournecovidmanagement.cloudfunctions.net/rssToJson",
      qs: {
        url: url
      },
      headers: {},
      json: true // Automatically parses the JSON string in the response
    };

    rp(options)
      .then(response => {
        let responseData = response.items.map(item => {
          usePubDate
            ? (item.date = moment(item.pubDate).format("DD/MM/YY"))
            : (item.date = moment(item.date).format("DD/MM/YY"));
          return item;
        });
        resolve(responseData);
      })
      .catch(error => {
        reject(error);
      });
  });
};
